(() => {
  'use strict';

  const setOpen = (item, open) => {
    const trigger = item.querySelector('[data-accordion-trigger]');
    item.toggleAttribute('data-open', open);
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const toggle = (trigger) => {
    const item = trigger.closest('[data-accordion-item]');
    if (!item) return;

    const willOpen = !item.hasAttribute('data-open');
    const group = trigger.closest('[data-accordion-single]');

    if (group && willOpen) {
      for (const open of group.querySelectorAll('[data-accordion-item][data-open]')) {
        if (open !== item) setOpen(open, false);
      }
    }

    setOpen(item, willOpen);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-accordion-trigger]');
    if (!trigger?.closest('[data-accordion]')) return;
    event.preventDefault();
    toggle(trigger);
  });
})();
